import { UserId } from '@business/entities/account';
import { InvoiceDiscountData } from '@modules/common/InvoiceDiscount';
import { ContactId } from '../contact';

export enum StripeSubscriptionStatus {
  active = 'active',
  trialing = 'trialing',
  past_due = 'past_due',
  unpaid = 'unpaid',
  canceled = 'canceled',
  incomplete = 'incomplete',
  incomplete_expired = 'incomplete_expired',
}

export enum SubscriptionInterval {
  monthly = 'monthly',
  quarterly = 'quarterly',
  biannualy = 'bi-annually',
  yearly = 'yearly',
}

export interface LineItem {
  id: number;
  serviceId: string;
  productId: string;
  packageId: string;
  classId: string;
  service: string;
  qty: number;
  unitPrice: number;
  title: string;
  description: string;
  saleRep: UserId;
  saleRep2: UserId;
  taxable: boolean;
  vendorId: string;
  productSku: string;
  unitOfMeasure: string;
  thumbnail: string;
  packageItems: LineItem[];
}

export type SubscriptionId = string;
export interface SubscriptionResponse extends SubscriptionMulticurencyResponse {
  id: SubscriptionId;
  name: string;
  title: string;
  invoiceId: number;
  amount: number;
  cycle: SubscriptionInterval;
  startDate: number;
  invoiceDate: number;
  isCanceled: boolean;
  isOverdue: boolean;
  canceledAt: number | null;
  nextDate: number | null;
  paymentMethodId?: string;
  contactEmail?: string;
  contactId: ContactId;
  saleRepId?: UserId;
  canResend: boolean;
  lineItems: LineItem[];
  memo: string;
  message: string;
  discount: InvoiceDiscountData;
  isStripe: boolean;
  stripeStatus: StripeSubscriptionStatus;
  hasStarted: boolean;
}
export interface SubscriptionMulticurencyResponse {
  subAmountDefault: number;
}
